import { DefaultUrlSerializer, UrlTree } from '@angular/router';

import { DIALOG_URL_PARAM } from './dialog-link.types';

const SAFE_RAW_RE = /^[A-Za-z0-9_.~%(),=-]*$/;

function encodeStrict(v: string): string {
  return encodeURIComponent(v).replace(/[!'()*]/g, (c) => '%' + c.charCodeAt(0).toString(16).toUpperCase());
}

/**
 * Writes and reads the repeated `dlg` query param VERBATIM (`?dlg=article(id=42)&dlg=comment(id=7)`)
 * instead of Angular's double encoding. Every other URL serializes exactly as before.
 */
export class DialogAwareUrlSerializer extends DefaultUrlSerializer {
  override parse(url: string): UrlTree {
    const tree = super.parse(url);
    const qStart = url.indexOf('?');
    if (qStart < 0) return tree;
    const hash = url.indexOf('#');
    const query = url.slice(qStart + 1, hash >= 0 && hash > qStart ? hash : undefined);
    const prefix = `${DIALOG_URL_PARAM}=`;
    const raws = query
      .split('&')
      .filter((p) => p.startsWith(prefix))
      .map((p) => p.slice(prefix.length));
    if (raws.length === 0) return tree;
    tree.queryParams = { ...tree.queryParams, [DIALOG_URL_PARAM]: raws.length === 1 ? raws[0] : raws };
    return tree;
  }

  override serialize(tree: UrlTree): string {
    const dlg = tree.queryParams[DIALOG_URL_PARAM];
    const values: string[] = (Array.isArray(dlg) ? dlg : dlg == null ? [] : [dlg]).map(String);
    if (values.length === 0) return super.serialize(tree);
    const rest = { ...tree.queryParams };
    delete rest[DIALOG_URL_PARAM];
    const base = super.serialize(new UrlTree(tree.root, rest, tree.fragment));
    const hash = base.indexOf('#');
    const head = hash >= 0 ? base.slice(0, hash) : base;
    const tail = hash >= 0 ? base.slice(hash) : '';
    const written = values.map((v) => `${DIALOG_URL_PARAM}=${SAFE_RAW_RE.test(v) ? v : encodeStrict(v)}`).join('&');
    return `${head}${head.includes('?') ? '&' : '?'}${written}${tail}`;
  }
}
